"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTask_1 = require("./BaseTask");
/*
 * [[CreatePeerConnectionTask]] sets up the peer connection object.
 */


var CreatePeerConnectionTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(CreatePeerConnectionTask, _BaseTask_1$default);

  var _super = _createSuper(CreatePeerConnectionTask);

  function CreatePeerConnectionTask(context) {
    var _this;

    _classCallCheck(this, CreatePeerConnectionTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'CreatePeerConnectionTask';
    _this.removeTrackAddedEventListener = null;
    _this.removeTrackRemovedEventListeners = {};
    _this.trackEvents = ['ended', 'mute', 'unmute', 'isolationchange', 'overconstrained'];
    _this.removeVideoTrackEventListeners = {};

    _this.trackAddedHandler = function (event) {
      var track = event.track;

      _this.context.logger.info("received track event: kind=".concat(track.kind, " id=").concat(track.id, " label=").concat(track.label));

      if (event.transceiver && event.transceiver.currentDirection === 'inactive') {
        return;
      }

      if (event.streams.length === 0) {
        _this.context.logger.warn("Track event but no stream");

        return;
      }

      var stream = event.streams[0];

      if (track.kind === 'audio') {
        _this.context.audioMixController.bindAudioStream(stream);
      } else if (track.kind === 'video' && !_this.trackIsVideoInput(track)) {
        _this.addRemoteVideoTrack(track, stream);
      }
    };

    return _this;
  }

  _createClass(CreatePeerConnectionTask, [{
    key: "removeObserver",
    value: function removeObserver() {
      this.removeTrackAddedEventListener && this.removeTrackAddedEventListener();

      for (var trackId in this.removeTrackRemovedEventListeners) {
        this.removeTrackRemovedEventListeners[trackId]();
      }
    }
  }, {
    key: "addPeerConnectionEventLogger",
    value: function addPeerConnectionEventLogger() {
      var _this2 = this;

      var peer = this.context.peer;
      peer.addEventListener('connectionstatechange', function () {
        _this2.context.logger.info("peer connection state changed: ".concat(peer.connectionState));
      });
      peer.addEventListener('negotiationneeded', function () {
        _this2.context.logger.info('peer connection negotiation is needed');
      });
      peer.addEventListener('icegatheringstatechange', function () {
        _this2.context.logger.info("peer connection ice gathering state changed: ".concat(peer.iceGatheringState));
      });
      peer.addEventListener('icecandidate', function (event) {
        _this2.context.logger.info("peer connection ice candidate: ".concat(event.candidate ? event.candidate.candidate : '(null)'));
      });
      peer.addEventListener('iceconnectionstatechange', function () {
        _this2.context.logger.info("peer connection ice connection state changed: ".concat(peer.iceConnectionState));
      });
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this3 = this;

        var hasTurnCredentials, configuration, connectionConstraints;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.context.removableObservers.push(this);
                hasTurnCredentials = this.context.turnCredentials && this.context.turnCredentials.uris.length > 0;
                configuration = hasTurnCredentials ? {
                  iceServers: [{
                    urls: this.context.turnCredentials.uris,
                    username: this.context.turnCredentials.username,
                    credential: this.context.turnCredentials.password,
                    credentialType: 'password'
                  }],
                  iceTransportPolicy: 'relay'
                } : {};
                configuration.bundlePolicy = this.context.browserBehavior.requiresBundlePolicy(); // @ts-ignore

                configuration.sdpSemantics = this.context.browserBehavior.requiresUnifiedPlan() ? 'unified-plan' : 'plan-b'; // @ts-ignore

                this.logger.info("SDP semantics are ".concat(configuration.sdpSemantics));
                connectionConstraints = {
                  optional: [{
                    googCpuOveruseDetection: false
                  }, {
                    googCombinedAudioVideoBwe: true
                  }]
                };

                if (this.context.peer) {
                  this.context.logger.info('reusing peer connection');
                } else {
                  this.context.logger.info('creating new peer connection'); // @ts-ignore

                  this.context.peer = new RTCPeerConnection(configuration, connectionConstraints);
                  this.addPeerConnectionEventLogger();
                }

                this.removeTrackAddedEventListener = function () {
                  if (_this3.context.peer) {
                    _this3.context.peer.removeEventListener('track', _this3.trackAddedHandler);
                  }

                  _this3.removeTrackAddedEventListener = null;
                };

                this.context.peer.addEventListener('track', this.trackAddedHandler);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "trackIsVideoInput",
    value: function trackIsVideoInput(track) {
      if (this.context.transceiverController.useTransceivers()) {
        this.logger.debug(function () {
          return "getting video track type (unified-plan)";
        });
        return this.context.transceiverController.trackIsVideoInput(track);
      }

      this.logger.debug(function () {
        return "getting video track type (plan-b)";
      });

      if (this.context.activeVideoInput) {
        var tracks = this.context.activeVideoInput.getVideoTracks();

        if (tracks && tracks.length > 0 && tracks[0].id === track.id) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "addRemoteVideoTrack",
    value: function addRemoteVideoTrack(track, stream) {
      var _this4 = this;

      var _a;

      var trackId = stream.id;

      if (!this.context.browserBehavior.requiresUnifiedPlan()) {
        stream = new MediaStream([track]);
        trackId = track.id;
      }

      var attendeeId = this.context.videoStreamIndex.attendeeIdForTrack(trackId);
      var skipAdding;
      var tile;

      if (this.context.videoTileController.getVideoTileForAttendeeId) {
        tile = this.context.videoTileController.getVideoTileForAttendeeId(attendeeId);
        skipAdding = !!((_a = tile === null || tile === void 0 ? void 0 : tile.state()) === null || _a === void 0 ? void 0 : _a.boundVideoStream);
      } else {
        skipAdding = this.context.videoTileController.haveVideoTileForAttendeeId(attendeeId);
      }

      if (skipAdding) {
        this.context.logger.info("Not adding remote track. Already have tile for attendeeId:  ".concat(attendeeId));
        return;
      }

      if (!tile) {
        tile = this.context.videoTileController.addVideoTile();
        this.logger.info("Created video tile ".concat(tile.id()));
      }

      var streamId = this.context.videoStreamIndex.streamIdForTrack(trackId);

      if (typeof streamId === 'undefined') {
        this.logger.warn("stream not found for tile=".concat(tile.id(), " track=").concat(trackId));
        streamId = null;
      }

      var _loop = function _loop(i) {
        var trackEvent = _this4.trackEvents[i];
        var videoTracks = stream.getVideoTracks();

        if (videoTracks && videoTracks.length) {
          var videoTrack = videoTracks[0];

          var callback = function callback() {
            _this4.context.logger.info("received the ".concat(trackEvent, " event for tile=").concat(tile.id(), " id=").concat(track.id, " streamId=").concat(streamId));

            if (trackEvent === 'ended' && _this4.context.browserBehavior.requiresUnifiedPlan()) {
              _this4.removeRemoteVideoTrack(track, tile.state());
            }
          };

          videoTrack.addEventListener(trackEvent, callback);

          if (!_this4.removeVideoTrackEventListeners[track.id]) {
            _this4.removeVideoTrackEventListeners[track.id] = [];
          }

          _this4.removeVideoTrackEventListeners[track.id].push(function () {
            videoTrack.removeEventListener(trackEvent, callback);
          });
        }
      };

      for (var i = 0; i < this.trackEvents.length; i++) {
        _loop(i);
      }

      var width;
      var height;

      if (track.getSettings) {
        var cap = track.getSettings();
        width = cap.width;
        height = cap.height;
      } else {
        var _cap = track.getCapabilities();

        width = _cap.width;
        height = _cap.height;
      }

      var externalUserId = this.context.videoStreamIndex.externalUserIdForTrack(trackId);
      tile.bindVideoStream(attendeeId, false, stream, width, height, streamId, externalUserId);
      this.logger.info("video track added, use tile=".concat(tile.id(), " track=").concat(trackId, " streamId=").concat(streamId));
      var endEvent = 'removetrack';
      var target = stream;

      if (!this.context.browserBehavior.requiresUnifiedPlan()) {
        this.logger.debug(function () {
          return 'updating end event and target track (plan-b)';
        });
        endEvent = 'ended'; // @ts-ignore

        target = track;
      }

      var trackRemovedHandler = function trackRemovedHandler() {
        return _this4.removeRemoteVideoTrack(track, tile.state());
      };

      this.removeTrackRemovedEventListeners[track.id] = function () {
        target.removeEventListener(endEvent, trackRemovedHandler);
        delete _this4.removeTrackRemovedEventListeners[track.id];
      };

      target.addEventListener(endEvent, trackRemovedHandler);
    }
  }, {
    key: "removeRemoteVideoTrack",
    value: function removeRemoteVideoTrack(track, tileState) {
      if (this.removeTrackRemovedEventListeners.hasOwnProperty(track.id)) {
        this.removeTrackRemovedEventListeners[track.id]();

        var _iterator = _createForOfIteratorHelper(this.removeVideoTrackEventListeners[track.id]),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var removeVideoTrackEventListener = _step.value;
            removeVideoTrackEventListener();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        delete this.removeVideoTrackEventListeners[track.id];
      }

      this.logger.info("video track ended, removing tile=".concat(tileState.tileId, " id=").concat(track.id, " stream=").concat(tileState.streamId));

      if (tileState.streamId) {
        this.context.videosPaused.remove(tileState.streamId);
      } else {
        this.logger.warn("no stream found for tile=".concat(tileState.tileId));
      }

      this.context.videoTileController.removeVideoTile(tileState.tileId);
    }
  }]);

  return CreatePeerConnectionTask;
}(BaseTask_1.default);

exports.default = CreatePeerConnectionTask;
CreatePeerConnectionTask.REMOVE_HANDLER_INTERVAL_MS = 10000;